export default "__VITE_ASSET__B5Ino48f__"